import * as React from 'react'
import * as cn from 'classnames'
import { Button, ButtonProps, Translucent } from '@amzn/dvui/dist/Button'
import { WatchParty } from '@amzn/dvui/dist/Icons/WatchParty'
import { StringId } from '../localizer/stringId'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import * as st from './watchPartyLink.module.scss'
import { ActionForm } from '../../utils/actionForm'
import { isTreatment } from '../../utils/utils'
import { AtfTreatment } from '../../reducers/features'
import { TextLocalizer } from '../localizer/localizer'

export interface WatchPartyLinkProps {
  watchPartyAction: WpsRuntime.atv.wps.WatchPartyActionProps
  buttonClassName?: string
  atfTreatment?: AtfTreatment
  isButton?: boolean
}

export const WatchPartyLink = ({ watchPartyAction, buttonClassName, atfTreatment, isButton }: WatchPartyLinkProps) => {
  if (!watchPartyAction) {
    return null
  }

  const { endpoint: { partialURL, query } } = watchPartyAction
  const atfTreatmentProps: ButtonProps = {
    ...(isTreatment(atfTreatment,'T1', 'T3') && {
      shape: 'pill',
      use: Translucent
    })
  }

  return (
    <ActionForm action={partialURL} method={'POST'} hiddenInputs={query}>
      {isButton ?
        <span className={cn({ [st.watchPartyButtonWrapper]: isTreatment(atfTreatment, 'T1', 'T2', 'T3') })}>
          <Button
            className={cn(
              st.button,
              {[st.watchPartyButton]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')},
              {buttonClassName: Boolean(buttonClassName)}
            )}
            forceDoubleHeight={!isTreatment(atfTreatment, 'T1', 'T2', 'T3')}
            data-ux-click
            type="submit"
            icon={<WatchParty />}
            {...atfTreatmentProps}
          >
            <TextLocalizer stringID={StringId.DV_DP_CREATE_WATCH_PARTY}/>
          </Button>
        </span> :
        <button className={cn(st.submit, buttonClassName)}>
          <TextLocalizer stringID={StringId.DV_DP_CREATE_WATCH_PARTY}/>
        </button>
      }
    </ActionForm>
  )
}
